import { render, staticRenderFns } from "./LogoPage.vue?vue&type=template&id=f1bf1a12&scoped=true&"
import script from "./LogoPage.vue?vue&type=script&lang=js&"
export * from "./LogoPage.vue?vue&type=script&lang=js&"
import style0 from "./LogoPage.vue?vue&type=style&index=0&id=f1bf1a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bf1a12",
  null
  
)

export default component.exports